// Element or selector type
export type ElementOrSelector = Element | string;

// Popper available placements
export type Placement = keyof typeof PLACEMENTS;
export const PLACEMENTS = {
  'top-start': 'top-start',
  'top-end': 'top-end',
  'bottom-end': 'bottom-end',
  'bottom-start': 'bottom-start',
  'left-end': 'left-end',
  'left-start': 'left-start',
  'right-end': 'right-end',
  'right-start': 'right-start',
  right: 'right',
  left: 'left',
  top: 'top',
  bottom: 'bottom',
  auto: 'auto',
};

/**
 *
 * @param element Element or selector to get
 * @param hostReference Reference to the host element
 * @param returnsNull Either returns null or the parent element
 * @returns
 */
export function getElementReference(
  hostReference: Element,
  element?: ElementOrSelector,
  returnsNull = false,
): Element | null {
  if (!element) {
    if (returnsNull) {
      return null;
    }
    return hostReference.parentElement;
  }

  const rootNode = hostReference.getRootNode() as Element;
  if (typeof element === 'string') {
    return rootNode.querySelector(element) || (returnsNull ? null : hostReference.parentElement);
  }
  return element;
}
